import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIWizardHeaderWithOverview from 'UIComponents/dialog/UIWizardHeaderWithOverview';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import UIList from 'UIComponents/list/UIList';
import UIBadge from 'UIComponents/badge/UIBadge';
import { LORAX } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import H3 from 'UIComponents/elements/headings/H3';
import * as ReviewTypes from '../../constants/ReviewType';
const ICON_SIZE = 40;
const Heading = styled(H3).withConfig({
  displayName: "StepHeader__Heading",
  componentId: "j24hr4-0"
})(["font-weight:bold;"]);
export default function StepHeader({
  reviewableName,
  reviewableIconUrl,
  reviewableProvider,
  reviewType,
  versionNumber,
  stepProps,
  wizardProps
}) {
  const renderedTitle = useMemo(() => {
    switch (reviewType) {
      case ReviewTypes.APP:
        return /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "center",
          children: [/*#__PURE__*/_jsx(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIImage, {
              alt: reviewableName,
              "data-test-id": "app-wizard-header-image",
              src: reviewableIconUrl,
              width: 40
            }),
            children: /*#__PURE__*/_jsx(Heading, {
              className: "m-all-0",
              children: reviewableName
            })
          }), /*#__PURE__*/_jsx(Heading, {
            className: "m-x-2 m-y-0",
            children: "+"
          }), /*#__PURE__*/_jsx(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIIcon, {
              name: "sprocket",
              color: LORAX,
              size: ICON_SIZE
            }),
            children: /*#__PURE__*/_jsx(Heading, {
              className: "m-all-0",
              children: "HubSpot"
            })
          })]
        });

      case ReviewTypes.PROFILE:
        return /*#__PURE__*/_jsx(UIFlex, {
          justify: "center",
          children: /*#__PURE__*/_jsx(UIImage, {
            alt: reviewableName,
            "data-test-id": "profile-wizard-header-image",
            src: reviewableIconUrl,
            style: {
              maxHeight: 100,
              maxWidth: 260
            }
          })
        });

      case ReviewTypes.THEME:
        return /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          justify: "center",
          children: /*#__PURE__*/_jsxs(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIImage, {
              alt: reviewableName,
              "data-test-id": "theme-wizard-header-image",
              src: reviewableIconUrl,
              width: 100
            }),
            children: [/*#__PURE__*/_jsx(Heading, {
              className: "m-all-0",
              children: reviewableName
            }), /*#__PURE__*/_jsx(UIBadge, {
              use: "koala",
              className: "m-right-2",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-reviews.wizard.rate.header.THEME_BADGE"
              })
            }), /*#__PURE__*/_jsxs(UIList, {
              inline: true,
              use: "inline-divided",
              children: [reviewableProvider && /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-ui-reviews.wizard.rate.header.PROVIDER",
                  options: {
                    provider: reviewableProvider
                  }
                })
              }), versionNumber && /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-ui-reviews.wizard.rate.header.VERSION",
                  options: {
                    version: versionNumber
                  }
                })
              })]
            })]
          })
        });

      case ReviewTypes.MODULE:
        return /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          justify: "center",
          children: /*#__PURE__*/_jsxs(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIImage, {
              alt: reviewableName,
              "data-test-id": "module-wizard-header-image",
              src: reviewableIconUrl,
              width: 100
            }),
            children: [/*#__PURE__*/_jsx(Heading, {
              className: "m-all-0",
              children: reviewableName
            }), /*#__PURE__*/_jsx(UIBadge, {
              use: "koala",
              className: "m-right-2",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-reviews.wizard.rate.header.MODULE_BADGE"
              })
            }), /*#__PURE__*/_jsxs(UIList, {
              inline: true,
              use: "inline-divided",
              children: [reviewableProvider && /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-ui-reviews.wizard.rate.header.PROVIDER",
                  options: {
                    provider: reviewableProvider
                  }
                })
              }), versionNumber && /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-ui-reviews.wizard.rate.header.VERSION",
                  options: {
                    version: versionNumber
                  }
                })
              })]
            })]
          })
        });

      default:
        return null;
    }
  }, [reviewableName, reviewableIconUrl, reviewableProvider, reviewType, versionNumber]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIWizardHeaderWithOverview, {
      stepProps: stepProps,
      wizardProps: wizardProps
    }), /*#__PURE__*/_jsxs("div", {
      className: "p-top-6",
      style: {
        margin: '0 10%'
      },
      children: [renderedTitle, /*#__PURE__*/_jsx(HR, {})]
    })]
  });
}